import { Injectable } from "@angular/core";
import { ProcessElementsResource } from "core/stages-client";
import { BehaviorSubject, combineLatest } from "rxjs";
import { NotificationInformation } from "files/notifications/filter-role/files-notifications.component";
import FileUpload = stages.file.FileUpload;
import UserWithAssignedRoles = stages.process.elements.UserWithAssignedRoles;

@Injectable({ providedIn: "root" })
export class FilesNotificationsService {
	lifecycleTpyeIdent$ = new BehaviorSubject<string | undefined>(undefined);
	nextLifecycleState$ = new BehaviorSubject<string | undefined>(undefined);
	lifecycleStateType$ = new BehaviorSubject<string | undefined>(undefined);
	lifecycleTpyeIdentInternal?: string;
	nextLifecycleStateInternal?: string;
	lifecycleStateTypeInternal?: string;
	constructor(private readonly processElementsResource: ProcessElementsResource) {
		combineLatest([this.lifecycleTpyeIdent$, this.nextLifecycleState$, this.lifecycleStateType$])
			.pipe()
			.subscribe(([lifecycleTypeIdent, nextLifecycleState, lifecycleStateType]) => {
				this.lifecycleTpyeIdentInternal = lifecycleTypeIdent;
				this.nextLifecycleStateInternal = nextLifecycleState;
				this.lifecycleStateTypeInternal = lifecycleStateType;
			});
	}

	setLifecycleTypeIdent(lifecycleTpyeIdent: string | undefined): void {
		if (this.lifecycleTpyeIdent$) {
			this.lifecycleTpyeIdent$.next(lifecycleTpyeIdent);
		} else {
			this.lifecycleTpyeIdent$ = new BehaviorSubject(lifecycleTpyeIdent);
		}
	}

	setNextLifecycleState(nextLifecycleState: string): void {
		this.nextLifecycleState$.next(nextLifecycleState);
	}

	setLifecycleStateType(lifecycleStateType: string): void {
		this.lifecycleStateType$.next(lifecycleStateType);
	}

	async loadUserRoles(
		workspaceId: string,
		type: string,
		id: string,
		queryParams?: NullableProperties<{ page?: number; pageSize?: number; pv?: string; isNewFile?: boolean }>,
	): Promise<SecuredPagedResult<UserWithAssignedRoles>> {
		const enhancedQueryParams = {
			page: queryParams?.page,
			pageSize: queryParams?.pageSize,
			pv: queryParams?.pv,
			isNewFile: queryParams?.isNewFile,
			lifecycleTypeIdent: this.lifecycleTpyeIdentInternal,
			nextLifecycleState: this.nextLifecycleStateInternal,
			lifecycleStateType: this.lifecycleStateTypeInternal,
		};
		return this.processElementsResource.getUsersWithAssignedRoles(workspaceId, type, id, enhancedQueryParams);
	}

	async sendNotificationsUpload(
		workspaceId: string,
		type: string,
		id: string,
		fileUpload: FileUpload,
		pv: string,
		notificationInformation: NotificationInformation,
		isNewFile?: boolean,
	): Promise<void> {
		return this.processElementsResource.sendNotificationsUpload(workspaceId, type, id, fileUpload, {
			pv: pv,
			sel: notificationInformation.selectedUserIds,
			nsel: notificationInformation.notSelectedUserIds,
			selectAll: notificationInformation.selectAllActive,
			deselectAll: notificationInformation.deselectAllActive,
			isNewFile: isNewFile,
			lifecycleTypeIdent: this.lifecycleTpyeIdentInternal,
			lifecycleStateType: this.lifecycleStateTypeInternal,
			nextLifecycleState: this.nextLifecycleStateInternal,
		});
	}

	async sendNotificationsSetState(
		workspaceId: string,
		type: string,
		id: string,
		fileId: string,
		pv: string,
		notificationInformation: NotificationInformation,
	): Promise<void> {
		return this.processElementsResource.sendNotificationsSetState(workspaceId, type, id, {
			fileId: fileId,
			pv: pv,
			sel: notificationInformation.selectedUserIds,
			nsel: notificationInformation.notSelectedUserIds,
			selectAll: notificationInformation.selectAllActive,
			deselectAll: notificationInformation.deselectAllActive,
			lifecycleTypeIdent: this.lifecycleTpyeIdentInternal,
			lifecycleStateType: this.lifecycleStateTypeInternal,
			nextLifecycleState: this.nextLifecycleStateInternal,
		});
	}
}
